export default __webpack_public_path__ + "static/media/flag.496c0ad5.png";